import { render, staticRenderFns } from "./website_branches.vue?vue&type=template&id=6f9224f1&scoped=true"
import script from "./website_branches.vue?vue&type=script&lang=js"
export * from "./website_branches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9224f1",
  null
  
)

export default component.exports